module.exports = __webpack_public_path__ + "f5bad06641799a2e7e87f1352ff1ec0c.svg";


//////////////////
// WEBPACK FOOTER
// ./app/containers/Premium/images/navigators/ic-section-live.svg
// module id = 1499
// module chunks = 3